import { createIcon } from '@chakra-ui/icon';
export var CaretUpIcon = createIcon({
  displayName: 'CaretUpIcon',
  viewBox: '0 0 14 24',
  d: 'M6.293 8.707a1 1 0 011.414 0l4.586 4.586c.63.63.184 1.707-.707 1.707H2.414c-.89 0-1.337-1.077-.707-1.707l4.586-4.586z'
});
//# sourceMappingURL=CaretUp.js.map